import Flyout from './Flyout';
import FlyoutBody from './FlyoutComponents/FlyoutBody';
import FlyoutFooter from './FlyoutComponents/FlyoutFooter';

export * from './FlyoutComponents/FlyoutTabs';

export default Flyout;

export { FlyoutBody, FlyoutFooter };
